import { PdSocialmedia } from "./pd-socialmedia/PdSocialmedia.js";
//#region src/pd-socialmedia/pd-socialmedia.ts
if (!customElements.get("pd-socialmedia")) customElements.define("pd-socialmedia", PdSocialmedia);
//#endregion
export { PdSocialmedia };
